<template>
    <div class="tracking-timeline__icon" :class="getClasses()">
        <font-awesome-icon :icon="getIcon()" />
    </div>
</template>

<script>
export default {
    name: "TimelineCircle",
    props: {
        status: {
            type: Boolean,
            default: null,
        }
    },
    methods: {
        getIcon() {
            if (this.status) {
                return "fa-solid fa-check";
            }
            else if (this.status === false) {
                return "fa-solid fa-xmark";
            }
            else {
                return "fa-solid fa-file-lines";
            }
        },
        getClasses() {
            return {
                "success": this.status,
                "fail": this.status === false,
            }
        }
    },
}
</script>